import React from "react";
import { ProductListScreenContextType } from "./types";

export const ProductListScreenContext = React.createContext<
  ProductListScreenContextType | undefined
>(undefined);
